/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState, useCallback, useRef } from 'react';
import { useDispatch, useSelector } from "react-redux";
import * as actions from "../../../../store/actions";
import { i18n } from '../../../../translate/i18n';
import {
	FormControl, Button, IconButton, FormControlLabel, Switch
} from '@mui/material';
import { FilterList } from "@mui/icons-material";
import CloseIcon from '@mui/icons-material/Close';

import { DivFormTitle } from './styles';
import Autocomplete from '../../../../UI/Autocomplete/Autocomplete';

const UsersFilterModal = (props) => {
	const dispatch = useDispatch();

	const [page] = useState(1);
	const [limit] = useState(30);
	const [orderBy] = useState("name");
	const [order] = useState("asc");

	const [searchTextSite, setSearchTextSite] = useState('');
	const [sitesFormated, setSitesFormated] = useState([]);
	const [selectedSites, setSelectedSites] = useState([]);

	const [selectedRoles, setSelectedRoles] = useState([]);
	const [searchTextRole, setSearchTextRole] = useState('');

	const fetchSites = useCallback(
		() => dispatch(actions.fetchSites(page, limit, searchTextSite, order, orderBy)),
		[page, limit, searchTextSite, order, orderBy]
	);
	
	const sites = useSelector(state => state.sites.sites);
	const roles = useSelector(state => state.users.roles);

	const filteredSites = useSelector(state => state.sites.selectedSitesPlaces);
	const filteredRoles = useSelector(state => state.users.usersFilter.filteredRoles);	
	const loadingSites = useSelector(state => state.sites.loading);

	useEffect(() => {
		handleInputChangeSites(filteredSites);
		setSelectedRoles(filteredRoles);
	}, []);

	useEffect(() => {
		fetchSites(limit, searchTextSite, order, orderBy);
	}, [searchTextSite]);
	
	useEffect(() => {
		const dataFromRedux = sites
		let returnArray = []
		dataFromRedux.rows.map(dt => returnArray.push({ value: dt._id, label: dt.name, ...dt }))
		setSitesFormated(returnArray)
	}, [sites])
	
	const handleInputChangeSelectorSites = (text) => {
		setSearchTextSite(text);
	}

	const handleInputChangeSelectorRoles = (text) => {
		setSearchTextRole(text);
	}

	const handleInputChangeSites = selected => {
		if(selected) {
			const dataFromRedux = selected
			let returnArray = []
			dataFromRedux.map(dt => returnArray.push({ value: dt._id, label: dt.name, ...dt }))
			setSelectedSites(returnArray);
		} else {
			setSelectedSites([]);
		}
	}

	const handleInputChangeRoles = selected => {
		setSelectedRoles(selected);
	}
	
	const handleClickFilter = () => {
		dispatch(actions.setSitePlaces(selectedSites));
		dispatch(actions.setUsersRolesFilter(selectedRoles));
		props.closeModal();
	}

	const handleClickClearFilters = () => {
		setSelectedSites([]);
	}
	
	return (
        <div style={styles.container}>			
			<DivFormTitle style={styles.headerContainer}>
				<div style={{ display: 'flex', alignItems: 'center', fontSize: '1.25rem' }}>
					<FilterList style={{ marginRight: '1rem' }} />
					{i18n.t('filterListModalfilterUser.filter')}
					{(selectedSites && selectedSites.length > 0) || (selectedRoles && selectedRoles.length > 0) &&
						<div style={styles.clearFilter} onClick={handleClickClearFilters}>{i18n.t('filterListModalfilterUser.clear')}</div>
					}
				</div>
				<IconButton onClick={props.closeModal} color='inherit' size="large">
					<CloseIcon />
				</IconButton>
			</DivFormTitle>
			
			<div style={styles.bodyContainer}>
				<FormControl variant="standard" fullWidth margin='normal'>
					<Autocomplete
						loading={loadingSites}
						label={i18n.t('autocompleteModalFilterUser.site')}
						data={sitesFormated}
						onSelectValue={handleInputChangeSites}
						valueSelected={selectedSites}
						newSearchText={handleInputChangeSelectorSites}
						isMulti
					/>
				</FormControl>
				<FormControl variant="standard" fullWidth margin='normal'>
					<Autocomplete
						label={i18n.t('autocompleteModalFilterUser.role')}
						data={roles}
						onSelectValue={handleInputChangeRoles}
						valueSelected={selectedRoles}
						newSearchText={handleInputChangeSelectorRoles}
						isMulti
					/>
				</FormControl>
			</div>

			<div style={styles.footerContainer}>
				<div
					onClick={props.closeModal}
					style={styles.buttonCancel}
				>
				{i18n.t('divModalFilterUser.cancel')}
				</div>
				<Button
					variant='contained'
					color='primary'
					onClick={handleClickFilter}
					style={styles.button}
				>
				{i18n.t('divModalFilterUser.ok')}
				</Button>
			</div>
		</div>
    );
}

const styles = {
	container: {
		width: '40rem',
		height: '100%'
	},
	headerContainer: {
		height: '5rem',
		padding: '0 1rem 0 2rem',
		backgroundColor: 'green',
		color: '#fff',
	},
	bodyContainer: {
		height: 'calc(100% - 10rem)',
		padding: '1rem 2rem',
		overflowY: 'auto',
		borderTop: '1px solid #ccc',
		borderBottom: '1px solid #ccc',
	},
	chip: {
		display: 'flex',
		alignItems: 'center',
		backgroundColor: '#C5D1E3',
		margin: '0.5rem 0',
		borderRadius: 10,
		padding: '0.3rem 1rem',
		justifyContent: 'space-between'
	},
	footerContainer: {
		height: '5rem',
		padding: '0 2rem',
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
	},
	button: {
		flex: 1,
		backgroundColor: 'green',
		borderRadius: '2rem',
		padding: '0.5rem 1.5rem',
		// width: '100%',
	},
	buttonCancel: {
		flex: 1,
		cursor: 'pointer',
		color: 'grey',
		alignItems: 'center',
		textAlign: 'center',
	},
	clearFilter: {
		fontSize: '1rem', 
		marginLeft: '2rem', 
		color: '#fff', 
		cursor: 'pointer', 
		textDecoration: 'underline' 
	}
}


export default UsersFilterModal;

